export default "/images/framework/Badge_01.4da53161.svg?4da53161";